import React, { ComponentType, ForwardedRef, forwardRef, useState } from 'react'
import { useOutsideClick } from '../hooks/UseOutsideClick'
import { useAppSelector } from '../../../app/store/hooks/Redux'
import { selectCanCloseDropdown } from '../../../app/store/reducers/AppSlice'

export interface IWithDropdownProps {
  open?: boolean
  onClose?: () => void
  onToggle?: () => void
  className?: string
}

export function withDropdown<T>(WrappedComponent: ComponentType<T>) {
  return forwardRef((props: IWithDropdownProps & T, ref: ForwardedRef<IWithDropdownProps & T>) => {
    const canCloseDropDown = useAppSelector(selectCanCloseDropdown)
    const [isOpen, setIsOpen] = useState(props.open)
    const clickRef = useOutsideClick(() => {
      if (canCloseDropDown) setIsOpen(false)
    })

    return (
      <div ref={clickRef} className={props.className} id='with-dropdown'>
        <WrappedComponent
          {...props}
          ref={ref}
          open={isOpen}
          onToggle={() => {
            setIsOpen(!isOpen)
            props.onToggle && props.onToggle()
          }}
          onClose={() => setIsOpen(false)}
          onFocus={() => setIsOpen(true)}
        ></WrappedComponent>
      </div>
    )
  })
}
